import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./TabButtonGroup.module.scss";
import Ripple from "@Components/Ripple";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

type TabButtonProps = {
  label: string;
  isActive: boolean;
  index: number;
  handleClick?: () => void;
  inputName: string;
  className?: string;
  shouldShowVertical?: boolean;
};

const TabButton = ({
  label,
  isActive,
  index,
  handleClick,
  inputName,
  className = "",
  shouldShowVertical = false,
}: TabButtonProps) => {
  const { t } = useTranslationHook();
  return (
    <>
      <div
        key={index}
        role="none"
        className={formatClassNames(styles.tabButton, className, isActive ? styles.active : "")}
      >
        <Ripple onClick={() => handleClick?.()} color="darkBlack" dataTestId={label} />
        <div
          data-testid={label}
          role="none"
          key={`${label}_${index}`}
          className={formatClassNames(styles.radioInput, shouldShowVertical ? styles.vertical : "")}
        >
          <input type="radio" value={label} checked={isActive} name={inputName} />
          <div className={styles.radioCheckmark} />
          <div>{t(label)}</div>
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(TabButton, {
  componentName: "TabButton-TabButtonGroup-BookForm",
  showForChina: true,
});
